<template lang="pug">
  section.section
    Loader(v-show="isLoading")
    .columns(v-show="hayDatos")
      .column
        typeahead(:options="items" v-model="itemSel")
      .column
        a.button.is-primary.is-rounded.is-medium(@click="addItem") Agregar
    .columns(v-show="!hayDatos")
      .column
        .notification.is-danger No existen Artículos para enviar.
</template>

<script>
import Loader from '../shared/Loader.vue'
import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'
import InventarioServices from '../../services/inventario/inventario';
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'AutocompleteArticulos',
  components: { Loader, Typeahead },
  props: {
    salida: {}
  },
  data () {
    return {
      itemSel: {},
      isLoading: false,
      items: [],
      hayDatos: false
    }
  },
  watch: {
    actCompAutocomplete () {
      this.actualizarComponente()
    }
  },
  methods: {
    actualizarComponente () {
      if (this.actCompAutocomplete) {
        this.getData()
      }
    },
    getData () {
      console.log(this.salida.tipo)
      console.log(this.salida.origen)
      InventarioServices.getItemsAutoComplete(this.salida.tipo,this.salida.origen)
        .then(res => {
          console.log(res.length)
          if (res.length > 0) {
            this.hayDatos = true
            this.items = res
            this.$store.commit('actComp_Autocomplete', false)
          } else {
            this.items = res
            this.hayDatos = false
            this.$store.commit('actComp_Autocomplete', false)
          }
          
        })
    },
    addItem () {
      this.isLoading = true
      console.log(this.itemSel)
      let id = Date.now()

      InventarioServices.addItemToSalida(id, this.salida.id, this.itemSel.id, this.itemSel.serie)
        .then(res => {
          console.log(res)
          if (res.success) {

            let idAddUbi = Date.now()
            let ahora = moment().format('YYYY-MM-DD HH:mm:ss')

            InventarioServices.addUbicacion(idAddUbi,this.itemSel.id, ahora, this.salida.destino,this.userLogin.id, this.userLogin.nombre,this.salida.idRecibe,this.salida.recibe,'1')
              .then(resAdd => {
                console.log(resAdd)
                if (resAdd.success) {
                  InventarioServices.updateUbicacionArt(this.itemSel.id, this.salida.destino,this.salida.idRecibe,this.salida.recibe)
                    .then(response => {
                      if (response.success) {
                        setTimeout(() => {
                          this.isLoading = false
                          this.$store.commit('actList_ItemSalida', true)
                          this.itemSel = {}
                          this.$emit('closeAutoCom')
                        },2000)
                      } else {
                        console.log(response.respuesta)
                      }
                    })
                } else {
                  console.log(resAdd.respuesta)
                }
              })
          } else {
            console.log(res.respuesta)
          }
        })
    },
    onSelect (value) {
      this.itemSel = value
    },
    onChange (value) {
      this.itemSel = value
    }
  },
  created () {
    this.getData()
  },
  computed: {
    ...mapState([
      'actCompAutocomplete',
      'userLogin'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventario_Componentes/AutocompleteArticulos.vue